import { useLoader } from "@/app/hook/use-loader";
import { useLocalization } from "@/app/hook/use-localization";
import { useNotifications } from "@/app/hook/use-notifications";
import { useQueueProcess } from "@/app/hook/use-queue-process";
import { useForm } from "@/base/utils/index";
import { useModalHardwareInstall } from "@/module/modal-hardware-install";
import { HardwareItemType } from "@/schemas/hardware";
import { serviceHardwareApi } from "@/services/hardware/index";
import { useEffect, useState } from "react";
import { useTableCanceled } from "../hooks/use-table-canceled";
import { useTableInstalled } from "../hooks/use-table-installed";
import { useTableToInstall } from "../hooks/use-table-to-install";

export type loaderDataProductType = {
  toInstallList: HardwareItemType[];
  installedList: HardwareItemType[];
  canceledList: HardwareItemType[];
};

export function usePageHardwareHook() {
  const [form] = useForm();
  const localization = useLocalization();
  const { show: showNotification } = useNotifications();
  const { setLoader } = useLoader();
  const loadProcessKey = "hardware-table";
  const { addQueueProcess } = useQueueProcess<null>(loadProcessKey);
  const [loadData, setLoadData] = useState<loaderDataProductType>({
    toInstallList: [],
    installedList: [],
    canceledList: [],
  });

  const controllerHardwareInstall = useModalHardwareInstall();

  const controllerDataTableCanceled = useTableCanceled(
    loadProcessKey,
    loadData.canceledList,
  );
  const controllerDataTableInstalled = useTableInstalled(
    loadProcessKey,
    loadData.installedList,
  );
  const controllerDataTableToInstall = useTableToInstall(
    loadProcessKey,
    loadData.toInstallList,
  );

  useEffect(() => {
    const fetchInit = async () => {
      addQueueProcess({
        data: null,
        promise: new Promise((resolveQueueProcess, rejectQueueProcess) => {
          serviceHardwareApi
            .fetchHardware()
            .then((hardwareItems) => {
              const toInstallList = hardwareItems.filter(
                (item) => item.IsNotInstalled === true,
              );
              const installedList = hardwareItems.filter(
                (item) => item.IsInstalled === true,
              );
              const canceledList = hardwareItems.filter(
                (item) => item.IsCanceled === true,
              );
              setLoadData({ toInstallList, installedList, canceledList });
              resolveQueueProcess(true);
            })
            .catch((error) => {
              rejectQueueProcess(error);
              showNotification(error);
            });
        }),
      });
    };
    setLoader(false);
    fetchInit();
  }, []);

  return {
    form,
    currentLang: localization?.currentLang,
    localization,
    controllerDataTableCanceled,
    controllerDataTableInstalled,
    controllerDataTableToInstall,
    controllerHardwareInstall,
  };
}
